const PATH = {
  auth: {
    forgotPassword: '/auth/forgotpassword',
    signIn: '/auth/signin',
    signUp: '/auth/signup',
    register: '/auth/register',
    becomeMember: '/auth/becomeMember',
    wechatCallback: '/auth/callback',
    externalCallback: '/auth/external/callback/:provider',
  },
  application: {
    select: '/select-application',
  },
  registration: '/registration',
  pbl: {
    dashboard: '/pbl/dashboard',
    calendar: '/pbl/calendar',
    volunteerRegistration: '/:lang/volunteerRegistration',
    lawyerApplicationStatus: '/pbl/lawyer/application-status',
    lawyerCv: '/pbl/lawyer/cv',
    vettingCvRevisions: '/pbl/vetting/cv-revisions',
    vettingCvRevisionDetail: '/pbl/vetting/cv-revisions/:revisionId',
    passwordlessLogin: '/api/pbl/passwordless/login/:user',
    passwordlessCallback: '/pbl/passwordless/callback',
    passwordSetup: '/pbl/password/setup',
    ocCitizenRegistration: '/pbl/oc/citizen-registration',
    ocCitizens: '/pbl/oc/citizens',
    ocCitizenDetail: '/pbl/oc/citizens/:profileId',
    citizenCases: '/pbl/citizen/cases',
    citizenCaseCreate: '/pbl/citizen/cases/new',
    citizenCaseEdit: '/pbl/citizen/cases/:caseId/edit',
    ocAssistedCaseCreate: '/pbl/oc/cases/new',
    cases: '/pbl/cases',
    pendingReviewCases: '/pbl/cases/pending-review',
    pendingReviewDetail: '/pbl/cases/pending-review/:caseId',
    caseDetail: '/pbl/cases/:caseId',
    appointmentConfirmation: '/pbl/cases/:caseId/appointment-confirmation',
    caseLawyers: '/pbl/cases/:caseId/lawyers',
    ocLawyerDirectory: '/pbl/oc/lawyers',
    ocAppointmentConfirmation: '/pbl/oc/cases/:caseId/appointment-confirmation',
    notifications: '/pbl/notifications',
    lawyerCases: '/pbl/lawyer/cases',
    lawyerMeetingCalendar: '/pbl/lawyer/cases/:caseId/meeting-calendar',
    lawyerCaseFeedback: '/pbl/lawyer/cases/:caseId/feedback',
    lawyerPendingReviewCases: '/pbl/lawyer/cases/pending-review',
    lawyerPendingReviewDetail: '/pbl/lawyer/cases/pending-review/:caseId',
    vettingApplications: '/pbl/vetting/applications',
    vettingDetail: '/pbl/vetting/applications/:profileId',
  },
  lei: '/lei',
  eCert: '/eCert',
  creditReport: '/creditReport',
  profile: {
    edit: '/profile/edit',
    accountEdit: '/profile/accountEdit',
    supplementalInfo: '/profile/supplementalInfo',
    identificationCheck: '/profile/identificationCheck',
    eCert: '/profile/eCert',
    creditReport: '/profile/creditReport',
    companyinfo: '/profile/companyinfo',
    personalinfo: '/profile/personalinfo',
    resetPassword: '/profile/resetPassword',
    comments: '/profile/comments',
    addNewMembers: '/profile/addNewMembers',
    editMembers: '/profile/addNewMembers/edit/:userId',
    subscriptionDetail: '/profile/subscriptionDetail',
    planPurchase: '/profile/plan-purchase',
    barrister: '/profile/barrister',
    identity: '/profile/identity',
  },
  home: {
    index: '/home',
    notifications: '/home/notifications',
    notificationDetail: '/home/notifications/:notificationId',
  },
  deal: {
    index: '/deal',
    initiation: '/deal/initiation',
    executionEdit: '/deal/:id/excution/edit',
    notificationDetails: '/deal/:id/details',
    detail: {
      index: 'deal/:id',
      manageParticipants: 'deal/:id/participants',
      manageFiles: 'deal/:id/files',
      contractSigning: '/deal/:id/contractSigning/:fileId',
      createMeeting: '/deal/:id/createMeeting',
    },
  },
  event: {
    index: '/event',
    newEvent: '/event/newEvent',
    joinMeeting: '/event/joinMeeting',
    meetingVideo: '/event/meetingVideo',
  },
  meetingRedirect: '/meeting/redirect',
  guestYellowPage: {
    index: '/:lang/eDirectory',
    detail: '/:lang/eDirectory/:id',
    comments: '/:lang/eDirectory/:id/comments',
  },
  yellowPage: {
    index: '/eDirectory',
    detail: '/eDirectory/:id',
    comments: '/eDirectory/:id/comments',
  },
  guestLawFirmsList: {
    index: '/:lang/professionalService',
    detail: '/:lang/professionalService/:id',
    comments: '/:lang/professionalService/:id/comments',
  },
  lawFirmsList: {
    index: '/professionalService',
    detail: '/professionalService/:id',
    comments: '/professionalService/:id/comments',
  },
  guestComapnyDetail: {
    index: '/:lang/companyDetail/:id',
  },
  comapnyDetail: {
    index: '/companyDetail/:id',
    comments: '/companyDetail/:id/comments',
  },
  features: {
    list: '/:lang/features',
    detail: '/:lang/features/:id',
  },
  blog: {
    list: '/:lang/Blog',
    detail: '/:lang/Blog/:cus_title',
  },
  services: '/:lang/services',
  subscription: '/:lang/Subscription',
  about: '/:lang/About',
  translate: '/translate',
  contractExpamples: '/contractTemplate',
  payment: {
    index: '/payment',
    detail: '/payment/:id',
  },
  docLibrary: '/docLibrary',
  blockchainDocuments: '/blockchainDocuments',
  documentsShared: '/sharedDocuments',
  documentsTranslate: '/documentsTranslate',
  aiMedia: '/aiMedia',
  eSignature: '/eSignature',
  signatureV2: {
    rosterInvitation: '/signature-v2/roster-invitations/:token',
    workflow: '/signature-v2/workflows/:workflowId',
    invitation: '/signature-v2/invitations/:token',
  },
  meeting: '/meeting',
  cart: {
    index: '/cart',
    checkout: '/cart/checkout',
    checkoutSuccess: '/cart/success',
    cancel: '/cart/cancel',
    stripeSuccess: '/stripe_cart/success',
    stripeCancel: '/stripe_cart/cancel',
    checkoutCreditReport: '/:lang/cart/success/credit-report',
    defaultCheckoutCreditReport: '/cart/success/credit-report',
  },
  chatRoom: '/chat',
  chatStart: '/chat/start/:userId',
  eSign: {
    uploadBankCard: '/eSign/myfacesign/uploadBankCard',
    customGetHWSign: '/eSign/myfacesign/customGetHWSign',
  },
  companyCreditReport: '/companyCreditReport',
  LEISearch: '/LEISearch',
  GuestSign: {
    success: '/success_sign',
    fail: '/fail_sign',
  },
  guest: {
    creditReport: '/:lang/guest/creditReport',
    getCreditReport: '/:lang/guest/getCreditReport',
    defaultGetCreditReport: '/guest/getCreditReport',
  },
  whatIsCR: '/:lang/whatIsCreditReport',
  addUserToSubAccount: '/addUserToSubAccount',
  testMCE: '/testMCE',
  page404: '/404',
  langPage404: '/:lang/404',
  termsUpdate: '/termsUpdate',
  share: '/:lang/share/:code',
  bridge: {
    index: '/register/bridge',
    setPassword: '/:lang/bridge/set-password',
  },
  goGlobal: {
    index: '/goGlobal',
    application: '/goGlobal/application',
    introduction: '/:lang/goGlobal',
  },
  guestGoGlobal: {
    introduction: '/goGlobal/introduction',
  },
  freeLegalLink: '/:lang/freelegallink',
};

export default PATH;
